import GeneralTranslations from "../../../Common/ModuleTranslations/fr";

export default {
  locale: "fr",
  name: "Politiques d'annulation",
  translation: { displayName: "Traductions" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "ordering",
        displayName: "Ordre",
      },
      {
        fieldName: "active",
        displayName: "Actif",
        restrictionMessage:
          "Politique liée à une condition. Il n'est pas possible d'effectuer cette action",
      },
      {
        fieldName: "name",
        displayName: "Nom",
      },
      {
        fieldName: "motorsList",
        displayName: "Moteurs",
      },
      {
        fieldName: "uso",
        displayName: "Utilisation",
      },
      {
        fieldName: "dates",
        displayName: "Dates",
      },
      {
        fieldName: "enableAutomaticCharge",
        displayName: "Frais automatiques",
      },
      {
        fieldName: "penaltyDeposit",
        displayName: "Collecte des dépenses en ligne",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "propertyTicker",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Actif",
      },
      {
        fieldName: "validFrom",
        placeholder: "Entrez une date",
        displayName: "Date de début",
        tooltip:
          "Cette date fait référence à la période durant laquelle le séjour aura lieu (fenêtre de voyage). La politique sera activée si les dates d'arrivée et de départ souhaitées se situent dans cette période",
      },
      {
        fieldName: "validTo",
        placeholder: "Entrez une date",
        displayName: "Date de fin",
      },
      {
        fieldName: "ordering",
        widget: "hidden",
      },
      {
        fieldName: "configurations",
        displayName: "Contraintes",
        introductionText: [
          "Créez différentes pénalités en fonction de l'anticipation de l'annulation",
          "Important ! Vérifiez que les politiques sont correctement appliquées dans le moteur",
        ],
        widget: "nestedEntity",
        nested: true,
        entityName: "CancellationPolicyConfiguration",
        defaultValue: [],
      },
      {
        fieldName: "agrWarningMessage",
        displayName: "",
      },
      {
        fieldName: "enableAutomaticCharge",
        widget: "checkbox",
        description: "Activer les frais automatiques en fonction des politiques d'annulation",
        helpText:
          "Lorsque vous activez cette option, la réservation sera facturée conformément aux délais de pénalité d'annulation. Cette option s'applique uniquement aux modes de paiement compatibles (modes de paiement permettant le report des frais dans le back-office du moteur).",
        defaultValue: false,
      },
      {
        fieldName: "penaltyDeposit",
        widget: "checkbox",
        description:
          "Exécuter le premier paiement en ligne - lors de la génération de frais au moment de la réservation",
        helpText:
          "En activant cette option et si des frais sont engagés au moment de la réservation, le dépôt de garantie sera facturé",
        defaultValue: false,
      },
      {
        fieldName: "description",
        placeholder: "Description",
        displayName: "Description",
      },
      {
        fieldName: "selectedMotorsSection",
        displayName: "Moteurs associés",
      },
    ],
  },
};
